import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { StorageEnum } from '@app/shared/enum/storage';
import { CancelHandler } from '@app/store/modal/modal.classes';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-edit-footer',
  templateUrl: './edit-footer.component.html',
})
export class EditFooterComponent {
  @Input() excuteText?: string = '保存';
  @Input() cancelText?: string = 'キャンセル';
  @Input() disabled?: boolean;
  @Input() navigationExtra?: NavigationExtras;
  @Input() navigationFinally?: Function;
  // @Input() closeFn?: Function;
  @Input() isCustomClose?: boolean;
  @Output() onCloseChange = new EventEmitter<void>();

  constructor(private router: Router, private store: Store) { }

  private defaultBackFunction() {
    this.router.navigate(['', { outlets: { edit: null } }], (this.navigationExtra || { replaceUrl: true, queryParamsHandling: "preserve" })).finally(() => {
      if (this.navigationFinally) {
        this.navigationFinally();
      }
    });
  }

  close(): void {
    this.store.dispatch(new CancelHandler());
    sessionStorage.setItem(StorageEnum.WEB_NAV, '1');
    if (!this.isCustomClose) {
      this.defaultBackFunction();
    }
    this.onCloseChange.emit();
  }
}
